import React, { useEffect, useState } from 'react'
import { TopHeadingTPO } from './style'

import { useDispatch } from 'react-redux'
import ApprovedIcon from '../../../src/components/icons/TPORequestsIcons/ApprovedIcon'
import DeclinedIcon from '../../../src/components/icons/TPORequestsIcons/DeclinedIcon'
import TotalIcon from '../../../src/components/icons/TPORequestsIcons/TotalIcon'
import UrgentIcon from '../../../src/components/icons/TPORequestsIcons/UrgentIcon'
import PlacementHistoryWithResume from '../../components/UIComponents/PlacementHistoryWithResume'
import { setUrgentCount } from '../../redux/Slices/tpoSlice'
import {
  JobRoleWholeFlex,
  LeftSection,
  RightSection,
  SectionName,
} from '../JobRoles/PageHeader/style'
import DashBoardCard from './Components/DashboardCard'
import TpoApprovalTable from './Components/TPOInfoTable'
import { useLocation } from 'react-router-dom'
import { ActionBarWrapper, SelectAllFlex, } from 'modules/Students/Style/style'
import Button from 'components/Button'

const TPORequests = ({
  getTPOMetrics,
  getTpoUserList,
  updateAllRequestList,
  getConsentDrawerList,
  getTPOFilter,
  getJobRolePreview,
  getStudentPlacedList,
  getPlacementHistoryList,
  getPreview,
}) => {
  const [selectedCard, setSelectedCard] = useState(1)
  const [metricsData, setMetricsData] = useState(null)
  const [tpoUserListData, setTpoUserListData] = useState([])
  const dispatch = useDispatch()
  const urgentCount = metricsData?.data?.data?.urgent_count
  const [loading, setLoading] = useState(false)
  const [companyData, setCompanyData] = useState([])
  const [prioritiesData, setPrioritiesData] = useState([])
  const [rolesDatas, setRolesDatas] = useState([])
  const [rulesDatas, setRulesDatas] = useState([])
  const [selectedCompany, setSelectedCompany] = useState([])
  const [selectedPriorities, setSelectedPriorities] = useState([])
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedRules, setSelectedRules] = useState([])
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [companySearchValue, setCompanySearchValue] = useState(null)
  const [roleSearchValue, setRoleSearchValue] = useState(null)
  const [pageNum, setPageNum] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [searchValue, setSearchValue] = useState(null)
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false)
  const [selectedFlag, setSelectedFlag] = useState('')
  const [selectedStudentRoles, setSelectedStudentRoles] = useState([])
  const [sortBy, setSortBy] = useState('')
  const [order, setOrder] = useState('')
  const [selectAll, setSelectAll] = useState(false)
  const [studentId, setStudentId] = useState('')
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [selectedKeys, setSelectedKeys] = useState([])
  const [pageSelectedCount, setPageSelectedCount] = useState(0)

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  const getFilterData = async ({ Pending, tabChange = false }) => {
    try {
      const data = await getTPOFilter(
        Pending,
        companySearchValue === null || tabChange ? '' : companySearchValue,
        roleSearchValue == null || tabChange ? '' : roleSearchValue
      )
      setCompanyData(data.filterCompanyList || [])
      setRolesDatas(data.filterRoleList || [])
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    const tab = queryParams.get('tab')
    let card = 'PENDING'
    let cardNo = 1
    if (tab == 'urgent') {
      card = 'URGENT'
      cardNo = 2
    }
    setSelectedFlag(card)
    setSelectedCard(cardNo)
    getFilterData({ Pending: card })
    setPrioritiesData([
      { label: 'Priority 1 (<3 days)', color: '#F54B56', value: 'High' },
      { label: 'Priority 2 (3-5 days)', color: '#FF7400', value: 'Medium' },
      { label: 'Less Priority', color: '#CFCFCF', value: 'Low' },
    ])
    setRulesDatas([
      {
        label: 'Restricted – Absent for Evaluation Process',
        value: 'isAbsentLimit',
      },
      {
        label: 'Restricted – Not applied in initial eligible roles',
        value: 'isInitialMissedRole',
      },
      { label: 'Exceeded Maximum Application', value: 'isApplyLimit' },
      {
        label: 'Exceeded "Intent to Offer / Offer Accepted"',
        value: 'isOfferLimit',
      },
    ])
  }, [])

  const fetchMetrics = async ({
    selectedFlag,
    pageNum,
    pageSize,
    searchValue,
    sortBy,
    order,
    selectedCompany,
    selectedPriorities,
    selectedRoles,
    selectedRules,
  }) => {
    setLoading(true)

    try {
      const userListData = await getTpoUserList(
        selectedFlag,
        pageNum,
        pageSize,
        searchValue,
        sortBy,
        order,
        selectedCompany,
        selectedPriorities,
        selectedRoles,
        selectedRules
      )
      setTpoUserListData(userListData)

      const metrics = await getTPOMetrics()
      setMetricsData(metrics)

      if (metrics?.data?.data?.urgent_count !== undefined) {
        dispatch(setUrgentCount(metrics?.data?.data?.urgent_count))
      }
    } catch (error) {
      console.error('Error fetching metrics:', error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (selectedFlag) {
      fetchMetrics({
        selectedFlag,
        pageNum,
        pageSize,
        searchValue,
        sortBy,
        order,
        selectedCompany,
        selectedPriorities,
        selectedRoles,
        selectedRules,
      })
    }
  }, [
    getTpoUserList,
    getTPOMetrics,
    pageNum,
    pageSize,
    searchValue,
    selectedFlag,
    sortBy,
    order,
    dispatch,
  ])

  const cardData = [
    {
      key: 1,
      icon: <TotalIcon />,
      IconText: 'Total',
      text: 'TPO requests pending',
      value: metricsData?.data?.data?.pending_count,
    },
    {
      key: 2,
      IconText: 'Urgent',
      icon: <UrgentIcon />,
      text: 'TPO action required',
      backgroundColor: '#FFF0F0',
      value: urgentCount,
    },
    {
      key: 3,
      icon: <ApprovedIcon />,
      IconText: 'Req. approved',
      text: 'TPO  approved',
      value: metricsData?.data?.data?.approval_count,
    },
    {
      key: 4,
      icon: <DeclinedIcon />,
      IconText: 'Req. declined',
      text: 'TPO  declined',
      value: metricsData?.data?.data?.decline_count,
    },
  ]

  const handleCardClick = async key => {
    setSelectedCard(key)
    setLoading(true)
    setSearchValue(null)
    resetSelectionState()
    let flag = 'PENDING'
    if (key === 2) {
      flag = 'URGENT'
    } else if (key === 3) {
      flag = 'APPROVED'
    } else if (key === 4) {
      flag = 'DECLINED'
    }

    // Set the selected flag
    setCompanySearchValue(null)
    setRoleSearchValue(null)
    setSelectedFlag(flag)
    setIsSelectAllChecked(false)
    setSelectedStudentRoles([])
    setSelectAll(false)
    setSelectedKeys([])
    setSelectedCompany([])
    setSelectedPriorities([])
    setSelectedRoles([])
    setSelectedRules([])
    setSearchValue('')

    try {
      const userListData = await getTpoUserList(
        flag,
        pageNum,
        pageSize,
        searchValue
      )

      setTpoUserListData(userListData)
      getFilterData({ Pending: flag, tabChange: true })
    } catch (error) {
      console.error('Error fetching user list:', error)
    } finally {
      setLoading(false)
      setPageNum(0)
    }
  }

  const handleApplyFilter = async () => {
    let flag = 'PENDING'
    if (selectedCard === 2) {
      flag = 'URGENT'
    } else if (selectedCard === 3) {
      flag = 'APPROVED'
    } else if (selectedCard === 4) {
      flag = 'DECLINED'
    }

    const userListData = await getTpoUserList(
      flag,
      pageNum,
      pageSize,
      searchValue,
      order,
      sortBy,
      selectedCompany,
      selectedPriorities,
      selectedRoles,
      selectedRules
    )
    // setCompanySearchValue(null)
    // setRoleSearchValue(null)
    // getFilterData({ Pending: flag, tabChange: false })
    setTpoUserListData(userListData)
    setIsMenuOpen(false)
    setPageNum(0)
  }
  const handleFilterCancel = async () => {
    handleCallBackFilter()
    setIsMenuOpen(false)
    let flag = 'PENDING'
    if (selectedCard === 2) {
      flag = 'URGENT'
    } else if (selectedCard === 3) {
      flag = 'APPROVED'
    } else if (selectedCard === 4) {
      flag = 'DECLINED'
    }
    const userListData = await getTpoUserList(
      flag,
      pageNum,
      pageSize,
      '',
      '',
      '',
      ''
    )
    setTpoUserListData(userListData)
    setCompanySearchValue(null)
    setRoleSearchValue(null)
    getFilterData({ Pending: flag, tabChange: true })
  }

  useEffect(() => {
    if (companySearchValue?.length > 0) setCompanySearchValue('')
  }, [isMenuOpen])
  const handleCompanyCheckboxChange = company => {
    const isAlreadySelected = selectedCompany.some(
      selected => JSON.stringify(selected) === JSON.stringify(company)
    )

    if (isAlreadySelected) {
      setSelectedCompany(
        selectedCompany.filter(
          selected => JSON.stringify(selected) !== JSON.stringify(company)
        )
      )
    } else {
      setSelectedCompany([...selectedCompany, company])
    }
  }
  useEffect(() => {
    if (roleSearchValue?.length > 0) setRoleSearchValue('')
  }, [isMenuOpen])

  const handleRolesCheckboxChange = role => {
    const isAlreadySelectedRoles = selectedRoles.some(
      selected => JSON.stringify(selected) === JSON.stringify(role)
    )

    if (isAlreadySelectedRoles) {
      setSelectedRoles(
        selectedRoles.filter(
          selected => JSON.stringify(selected) !== JSON.stringify(role)
        )
      )
    } else {
      setSelectedRoles([...selectedRoles, role])
    }
  }

  const handleRulesCheckboxChange = rule => {
    if (selectedRules?.includes(rule)) {
      setSelectedRules(selectedRules.filter(item => item !== rule))
    } else {
      setSelectedRules([...selectedRules, rule])
    }
  }
  const handlePriorityCheckboxChange = priority => {
    if (selectedPriorities?.includes(priority)) {
      setSelectedPriorities(
        selectedPriorities.filter(item => item !== priority)
      )
    } else {
      setSelectedPriorities([...selectedPriorities, priority])
    }
  }
  const handleCompanySearch = e => {
    setCompanySearchValue(e.target.value)
  }

  const handleRoleSearch = e => {
    setRoleSearchValue(e.target.value)
  }

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      let flag = 'PENDING'
      if (selectedCard === 2) {
        flag = 'URGENT'
      } else if (selectedCard === 3) {
        flag = 'APPROVED'
      } else if (selectedCard === 4) {
        flag = 'DECLINED'
      }
      if (companySearchValue !== null || roleSearchValue !== null) {
        getFilterData({
          Pending: flag,
          companySearchValue,
          roleSearchValue,
        })
      }
    }, 500)

    return () => clearTimeout(delayDebounce)
  }, [companySearchValue, roleSearchValue])
  const handleCallBackFilter = () => {
    setSelectedCompany([])
    setSelectedPriorities([])
    setSelectedRules([])
    setSelectedRoles([])
  }

  const handleNameClick = data => {
    setStudentId(data?.student_id)
    setIsOpenHistory(true)
  }
  const resetSelectionState = () => {
  setSelectAll(false)
  setIsSelectAllChecked(false)
  setSelectedKeys([])
  setPageSelectedCount(0)
  setSelectedStudentRoles([])
}
  const totalStudentCount = tpoUserListData?.data?.data?.count ?? 0
  const canShowSelectAll = totalStudentCount > 10
  console.log('tpoUserListData', tpoUserListData)
  return (
    <JobRoleWholeFlex>
      <LeftSection>
        <SectionName>
          <TopHeadingTPO>TPO Requests</TopHeadingTPO>
        </SectionName>
      </LeftSection>
      <RightSection></RightSection>
      <DashBoardCard
        handleCardClick={handleCardClick}
        cardData={cardData}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
        showHeader
      />
      <ActionBarWrapper>
        {canShowSelectAll &&(pageSelectedCount > 0 || selectAll) && (
          <SelectAllFlex>
            <div style={{ fontSize: '13px',padding: '0px 20px' }}>
              Selected{' '}
              <strong>
                {selectAll
                  ? tpoUserListData?.data?.data?.count
                  : pageSelectedCount}{' '}
                {(selectAll
                  ? tpoUserListData?.data?.data?.count
                  : pageSelectedCount) > 1
                  ? 'students '
                  : 'student '}
              </strong>
              {selectAll ? 'from all pages' : 'from this page'}
            </div>
            {canShowSelectAll &&!selectAll && pageSelectedCount > 0 && (
              <Button.Primary
                text={
                <>
                  Select all{' '}
                  <span style={{ fontWeight: 800 }}> 
                    {`${tpoUserListData?.data?.data?.count} ${ tpoUserListData?.data?.data?.count > 1
                        ? 'students'
                        : 'student'
                    }`}
                  </span>{' '}
                  from all pages
                </>
              }
                fontsize={'0.8rem'}
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  setSelectAll(true)
                  setIsSelectAllChecked(true)
                  setPageSelectedCount(tpoUserListData?.data?.data?.count || 0)
                }}
              />
            )}
            {selectAll && (
              <Button.Primary
                text="Clear Selection"
                fontsize={'0.8rem'}
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  setSelectAll(false)
                  setIsSelectAllChecked(false)
                  setSelectedKeys([])
                  setPageSelectedCount(0)
                }}
              />
            )}
          </SelectAllFlex>
        )}
      </ActionBarWrapper>
      <TpoApprovalTable
        selectedCard={selectedCard}
        userList={tpoUserListData?.data}
        handleCompanyCheckboxChange={handleCompanyCheckboxChange}
        selectedCompany={selectedCompany}
        companyData={companyData}
        prioritiesData={prioritiesData}
        handlePriorityCheckboxChange={handlePriorityCheckboxChange}
        selectedPriorities={selectedPriorities}
        handleRolesCheckboxChange={handleRolesCheckboxChange}
        selectedRoles={selectedRoles}
        rolesDatas={rolesDatas}
        handleRulesCheckboxChange={handleRulesCheckboxChange}
        selectedRules={selectedRules}
        rulesDatas={rulesDatas}
        handleCallBackFilter={handleCallBackFilter}
        companySearchValue={companySearchValue}
        setCompanySearchValue={setCompanySearchValue}
        handleCompanySearch={handleCompanySearch}
        roleSearchValue={roleSearchValue}
        setRoleSearchValue={setRoleSearchValue}
        handleRoleSearch={handleRoleSearch}
        pageNum={pageNum}
        setPageNum={setPageNum}
        setPageSize={setPageSize}
        handleApplyFilter={handleApplyFilter}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        handleFilterCancel={handleFilterCancel}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        updateAllRequestList={updateAllRequestList}
        isSelectAllChecked={isSelectAllChecked}
        setIsSelectAllChecked={setIsSelectAllChecked}
        selectedStudentRoles={selectedStudentRoles}
        setSelectedStudentRoles={setSelectedStudentRoles}
        selectedFlag={selectedFlag}
        setSelectedFlag={setSelectedFlag}
        setSortBy={setSortBy}
        sortBy={sortBy}
        setOrder={setOrder}
        getTpoUserList={getTpoUserList}
        order={order}
        setSelectAll={setSelectAll}
        selectAll={selectAll}
        loading={loading}
        getConsentDrawerList={getConsentDrawerList}
        handleNameClick={handleNameClick}
        getTPOMetrics={getTPOMetrics}
        handleCardClick={handleCardClick}
        setMetricsData={setMetricsData}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        setPageSelectedCount={setPageSelectedCount}
      />
      <PlacementHistoryWithResume
        studentId={studentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreview}
      />
    </JobRoleWholeFlex>
  )
}

export default TPORequests
